import cloneDeep from 'lodash/cloneDeep';
import Customer from './customer';
import CustomerContact from './customerContact';
import Pool from './pool';
import moment from 'moment';

class TrashBin {
  constructor({
    dealerID,
    customerID,
    poolID,
    customerContactID,
    deleted,
    customer,
    contact,
    pool,
    type,
  }) {
    this.dealerID = dealerID;
    this.customerID = customerID;
    this.poolID = poolID;
    this.customerContactID = customerContactID;
    this.deleted = deleted && moment(deleted);
    this.customer = customer;
    this.contact = contact;
    this.pool = pool;
    this.type = type;
  }

  clone() {
    return cloneDeep(this);
  }

  toApiFormat() {
    return {
      DealerID: this.dealerID,
      CustomerID: this.customerID,
      PoolID: this.poolID,
      CustomerContactID: this.customerContactID,
      Deleted: this.deleted,
      Customer: this.customer ? this.customer.toApiFormat() : null,
      Contact: this.contact ? this.contact.toApiFormat() : null,
      Pool: this.pool ? this.pool.toApiFormat() : null,
      Type: this.type,
    };
  }

  static fromApiFormat(api) {

    return new TrashBin({
      dealerID: api.DealerID,
      customerID: api.CustomerID,
      poolID: api.PoolID,
      customerContactID: api.CustomerContactID,
      deleted: moment(api.Deleted),
      customer: api.Customer ? Customer.fromApiFormat(api.Customer) : null,
      contact: api.Contact ? CustomerContact.fromApiFormat(api.Contact) : null,
      pool: api.Pool ? Pool.fromApiFormat(api.Pool) : null,
      type: api.Type,
    });

  }
}

export default TrashBin;
